import { CSSProperties, FC } from 'react'

import {
  IconCalendarDays,
  Button,
  Link,
  Tooltip
} from '@sequencehq/core-components'
import { match } from 'ts-pattern'

import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const ButtonViewSchedule: FC<{
  variant?: 'text' | 'icon'
  style?: CSSProperties
  'data-testid'?: string
}> = ({ variant = 'text', style, 'data-testid': dataTestId }) => {
  const ctx = useCubeContext()
  const billingScheduleId = ctx.queries.rawData.data.quote.billingScheduleId

  const label = 'View schedule'
  const icon = <IconCalendarDays color="inherit" />

  const buttonProps = match(variant)
    .with('text', () => ({ children: label }))
    .with('icon', () => ({ icon, 'aria-label': label }))
    .exhaustive()

  const button = (
    <Button
      variant="secondary"
      as={Link.Unstyled}
      to={`/billing-schedules/${billingScheduleId}`}
      {...buttonProps}
      style={style}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  )

  if (variant === 'icon') {
    return <Tooltip label={label}>{button}</Tooltip>
  }

  return button
}
